/*
|--------------------------------------------------------------------------
| Views: Basic
|--------------------------------------------------------------------------
*/

/**
 * Basic View
 * @namespace
 */
__gh__webApp.views.basic = {

	/**
	 * Post bucket laydown callbacks
	 * @param {object} bucket - bucket object
	 */
	"callbacks": function(bucket){
		var viewName	= bucket.view.name,
			commonJS	= __gh__webApp.common,
			social		= __gh__webApp.social;

		//Twitter
		if (commonJS.hasString(viewName.toLowerCase(), "twitter"))
		{
		    social.twitter.loadAllWidgets();
		}
	},


	"getSubView": function(bucket){
		var commonViewJS			= __gh__webApp.views.common,
			items 					= (bucket.items.main) ? bucket.items.main : {},
			viewFolder				= "buckets/basic",
			viewName,items,getItems;


		//Check first two items for an image and put image in the first slot, if the first doesn't have an image.
		var featuredImagePosition = __gh__webApp.data.itemValidator({"data":items.slice(0,2),"required":1,"validationMethod":"hasImage"});
		if(featuredImagePosition!==false && featuredImagePosition!==0){
			items.move(featuredImagePosition,0);
		}


		//Basic Headlines
		var firstFiveHaveImages = __gh__webApp.data.itemValidator({"data":items.slice(0,5),"required":5,"validationMethod":"hasImage"});
		if (featuredImagePosition===false || firstFiveHaveImages===false){
			return __gh__webApp.views.basicHeadlines.getSubView(bucket);
		}


		//Twitter - 3 images and twitter bucket
		var twitter 		= __gh__webApp.data.validate.bucket.hasTwitter(bucket);
		if (twitter){
			viewName 		= viewFolder+"/twitter";
			itemCount 		= 3;
			getItems		= commonViewJS.splitItems(items,itemCount,bucket);

			//Update bucket
			bucket.view.name 	= viewName;
			bucket.items 		= {
				"main"				:getItems.main,
				"moreHeadlines"		:getItems.moreHeadlines
			};
			return bucket;

		}


		//Multimedia - 4 images and gallery
		var multimediaPosition = __gh__webApp.data.itemValidator({"data":items,"required":1,"validationMethod":"isGallery"});
		if (multimediaPosition!==false){
			if(multimediaPosition!=2){
				items.move(multimediaPosition,1);
			}
			viewName 		= viewFolder+"/multimedia";
			itemCount 		= (bucket.hasAd) ? 4 : 6;
			getItems		= commonViewJS.splitItems(items,itemCount,bucket);

			//Update bucket
			bucket.view.name	= viewName,
			bucket.items 		= {
				"main"				:getItems.main,
				"moreHeadlines"		:getItems.moreHeadlines
			};
			return bucket;
		}


		//Basic - 5 images
		viewName 		= viewFolder+"/standard";
		itemCount 		= (bucket.hasAd) ? 5 : 7;
		getItems		= commonViewJS.splitItems(items,itemCount,bucket);

		//Update bucket
		bucket.view.name 	= viewName,
		bucket.items 		= {
				"main"				:getItems.main,
				"moreHeadlines"		:getItems.moreHeadlines
		};
		return bucket;


	}
};
